import React from "react";
import VerificationCodeForm, {
  VerificationCodeFormProps,
} from "./VerificationCodeForm";
import { MFAProvider } from "@/src/components/cards/components/ProductCard/components/ProductCardFooter/components/TokenTransferModule/TokenTransferModal/components/steps/VerifyAccount/SecurePhoneNumber/contexts/MFAContextProvider";
import {
  SecureNumberState,
  VerificationMethod,
} from "@/src/components/cards/components/ProductCard/components/ProductCardFooter/components/TokenTransferModule/TokenTransferModal/components/steps/VerifyAccount/SecurePhoneNumber/contexts/MFAContextProvider/types";

type MFAPhoneVerificationProps = {
  isEnabled: boolean;
  onSuccess: VerificationCodeFormProps["onSuccess"];
};

export default function MFAPhoneVerificationCode({
  isEnabled = false,
  onSuccess,
}: MFAPhoneVerificationProps) {
  return (
    <MFAProvider
      initialEnabled={isEnabled}
      initialVerificationMethod={VerificationMethod.PHONE_NUMBER}
      initialMFAState={SecureNumberState.VERIFICATION}
    >
      <VerificationCodeForm onSuccess={onSuccess} />
    </MFAProvider>
  );
}
